webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/**
 * Vue toast plugin
 * Created by zhangzongzheng on 2017/7/6
 */



/**
 * @param {HTMLElement} el target element
 * @param {string} text content of the toast
 * @param {string} type  type of the toast  "success" || "warning" || "info" || "error"
 * @param {number} duration  time before the toast vanishes, in millisecond
 * @param {number} top toast top
 * @param {number} left toast left
 */
function toast (el, text, type, duration, top, left) {
  if (!el) {
    throw new Error('target element should be assigned.')
  } else {
    var d = document.createElement('div')
    try {
      d.appendChild(el.cloneNode(true))
      if (el.nodeType !== 1) {
        throw new Error('target element is not HTMLElement.')
      }
    } catch (e) {
      throw new Error('target element is not HTMLElement.')
    }
  }

  if (text && typeof text !== 'string') {
    throw new Error('toast content is not string.')
  }

  if (type && ['success', 'warning', 'info', 'error'].indexOf(type) === -1) {
    throw new Error('toast type should be one of "success, warning, info, error".')
  }

  duration = duration || 4000
  if (isNaN(Number(duration))) {
    throw new Error('toast duration should be number.')
  }

  if (top && isNaN(Number(top))) {
    throw new Error('toast top should be number.')
  }

  if (left && isNaN(Number(left))) {
    throw new Error('toast left should be number.')
  }

  var toastEl = document.createElement('div')
  var rect = el.getBoundingClientRect()
  var scrollLeft = (document.documentElement && document.documentElement.scrollLeft) || document.body.scrollLeft
  var scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop

  toastEl.style.top = (Number(top) || rect.top + rect.height + scrollTop) + 'px'
  toastEl.style.left = (Number(left) || rect.left + rect.width + scrollLeft) + 'px'

  toastEl.innerHTML = text
  toastEl.className = 'vue-toast ' + type
  document.body.appendChild(toastEl)

  setTimeout(function () {
    toastEl.className += ' hide'
    setTimeout(function () {
      toastEl.parentNode.removeChild(toastEl)
    }, 450)
  }, Number(duration))
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function (Vue, options) {
    if (!Vue.prototype.$toast) {
      Vue.prototype.$toast = toast
    }
  }
});


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(6)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(8),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_index__ = __webpack_require__(0);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2__src_index__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  methods: {
    defaultt: function defaultt() {
      this.$toast(this.$refs.default, 'Default', '');
    },
    info: function info() {
      this.$toast(this.$refs.info, 'Information!', 'info');
    },
    success: function success() {
      this.$toast(this.$refs.success, 'Wonderful!', 'success');
    },
    warning: function warning() {
      this.$toast(this.$refs.warning, 'Attention!', 'warning');
    },
    error: function error() {
      this.$toast(this.$refs.error, 'Oops!', 'error');
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    ref: "default",
    staticClass: "default btn",
    on: {
      "click": _vm.defaultt
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('div', {
    ref: "info",
    staticClass: "info btn",
    on: {
      "click": _vm.info
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('div', {
    ref: "success",
    staticClass: "success btn",
    on: {
      "click": _vm.success
    }
  }, [_vm._v("success")]), _vm._v(" "), _c('div', {
    ref: "warning",
    staticClass: "warning btn",
    on: {
      "click": _vm.warning
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('div', {
    ref: "error",
    staticClass: "error btn",
    on: {
      "click": _vm.error
    }
  }, [_vm._v("error")])])
},staticRenderFns: []}

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.a8c629f86c580a6da017.js